import { CollectionRecord } from '@common/data-models/records/collection-record';
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { DateTime } from "@common/data-models/complex-types/date-time";
import { ObjectTypes } from '@common/enums/object-types';
import { Record } from '@common/data-models/records/record';
import { StoryRecord } from '@live/data-models/records/story-record';

export class RundownRecord extends CollectionRecord {
    constructor() {
        super();
        this.type = ObjectTypes.RUNDOWN;
    }

    // public get sequence(): Array<string> { return this.getAs<Array<string>>(PSTFieldNames.PSTRundownSequence); }
    // public set sequence(value: Array<string>) { this.set(PSTFieldNames.PSTRundownSequence, value); }
}
